/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostModelConfigPathParams = NonNullable<operations['postModelConfig']['parameters']['path']>;

export type PostModelConfigRequestBody = OperationRequestBodyContent<operations['postModelConfig']>;

export interface Input extends PostModelConfigPathParams {
  apiVersion?: string;
  body: PostModelConfigRequestBody;
}

export async function postModelConfig(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/ai-configs/model-configs', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
